
























































import { Component, Vue } from 'vue-property-decorator';
import { categoryManage } from './quotation';
import SelectProject from '@/components/selectProject.vue';

type ICategoryInfo = IQuotation.IResponse.ICategoryInfo;

interface ICategoryRowInfo extends ICategoryInfo {
  editable: boolean;
  isCreate?: boolean;
  [key: string]: any;
}

const columns = [
  {
    slots: { title: 'nameTitle' },
    dataIndex: 'name',
    scopedSlots: { customRender: 'name'},
    width: '20%',
  },
  {
    slots: { title: 'projectTitle' },
    dataIndex: 'projects',
    scopedSlots: { customRender: 'projects'},
    width: '40%',
  },
  {
    slots: { title: 'requiredTitle' },
    dataIndex: 'isRequired',
    scopedSlots: { customRender: 'isRequired'},
    width: '10%',
    align: 'center',
  },
  {
    slots: { title: 'additionalTitle' },
    dataIndex: 'isAdditional',
    scopedSlots: { customRender: 'isAdditional'},
    width: '10%',
    align: 'center',
  },
  {
    slots: { title: 'activeTitle' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'active'},
    width: '10%',
    align: 'center',
  },
  {
    slots: { title: 'actionTitle' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '10%',
    align: 'center',
  },
];
let cacheCategory: ICategoryRowInfo | null = null;

@Component({
  name: 'Quotation',
  components: {
    SelectProject,
  },
})
export default class Quotation extends Vue {
  private categoryList: ICategoryRowInfo[] = [];
  private loading = false;
  private columns = columns;
  private editingKey = '';
  private pagination = {
    hideOnSinglePage: true,
  };
  private spinning = false;
  get isEditing() {
    return this.editingKey !== '';
  }
  private created() {
    this.refreshCategorys();
  }
  private refreshCategorys() {
    this.resetStatus();
    this.spinning = true;
    categoryManage.requestGetCategorys().then((res) => {
      this.updateCategoryList();
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private resetStatus() {
    this.editingKey = '';
  }
  private updateCategoryList() {
    this.categoryList = categoryManage.data.map((category) => {
      return {
        ...category,
        editable: false,
      };
    });
  }
  private createCategory() {
    const category = categoryManage.createCategory();
    this.categoryList.unshift({
      ...category,
      editable: true,
      isCreate: true,
    });
    this.editingKey = category.id;
  }
  private editCategory(category: ICategoryRowInfo, index: number) {
    cacheCategory = {...this.categoryList[index]};
    category.editable = true;
    this.editingKey = category.id;
  }
  private cancelEdit(category: ICategoryRowInfo, index: number) {
    this.editingKey = '';
    if (category.isCreate) {
      this.categoryList.shift();
      return;
    }
    this.categoryList[index] = {...cacheCategory!};
  }
  private saveCategory(category: ICategoryRowInfo) {
    const {id, isRequired, isAdditional, name, active, projects} = category;
    const newCategory = {
      id, isRequired, isAdditional, name, active,
      projectIds: projects.map((project) => project.id),
    };
    this.loading = true;
    categoryManage.requestUpdateCategory(newCategory).then((res) => {
      if (category.isCreate) {
        categoryManage.addCategory(category);
        category.isCreate = false;
      } else {
        categoryManage.updateCategory(category);
      }
      category.editable = false;
      this.editingKey = '';
      this.$message.success(res);
      this.loading = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.loading = false;
    });
  }
  private submitDelete(categoryId: string) {
    categoryManage.requestDelCategory(categoryId).then((res) => {
      this.updateCategoryList();
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleDelCategory(category: ICategoryRowInfo) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(category.id);
      },
    });
  }
  private handleChange(value: any, rowId: string, column: string) {
    const newCategorys = [...this.categoryList];
    const target = newCategorys.filter((category) => rowId === category.id)[0];
    if (target) {
      const index = this.categoryList.findIndex((category) => target.id === category.id);
      if (['isAdditional', 'isRequired', 'active'].includes(column)) {
        target[column] = value ? true : false;
      } else {
        target[column] = value;
      }
      this.categoryList[index] = target;
    }
  }
  private convertProject = (projects: IProject.IResponse.IProjectInfo[]) => {
    return projects.map((project) => ({id: project.id, name: project.name}));
  }
}
